import { render, staticRenderFns } from "./_package.vue?vue&type=template&id=83bc0ce0&lang=pug"
import script from "./_package.vue?vue&type=script&lang=js"
export * from "./_package.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports